import { useState, ComponentType } from "react";
import { motion } from "framer-motion";
import { MenuDocument } from "prismicio-types";
import { styles as moduleStyles, HyamPrismicDocumentNavBar_DrawerStyles } from "./styles";
import { useEventListener } from "hyam-core/utils/eventTarget";
import {
  HyamPrismicDocumentMenu,
  HyamPrismicDocumentMenuMobile,
} from "hyam-prismic/components";
import { withConfigure } from "hyam-core/utils/withConfigure";
import { lock, unlock } from "hyam-core/utils/bodyScrollLock";

import cn from "classnames";
import { useBreakpointIndex } from "hyam-core/hooks/useBreakpoint";

export type HyamPrismicDocumentNavBar_DrawerProps = {
  document: MenuDocument;
  styles?: Partial<HyamPrismicDocumentNavBar_DrawerStyles>;
  stylesReplace?: Partial<HyamPrismicDocumentNavBar_DrawerStyles>;
  CloseIcon?: ComponentType;
};

const _HyamPrismicDocumentNavBar_Drawer = (
  props: HyamPrismicDocumentNavBar_DrawerProps,
) => {
  const styles = props.styles as HyamPrismicDocumentNavBar_DrawerStyles;

  const [show, setShow] = useState(false);

  const setShowTrue = () => {
    lock("HyamPrismicDocumentNavBar_Drawer");
    setShow(true);
  };

  const setShowFalse = () => {
    unlock("HyamPrismicDocumentNavBar_Drawer");
    setShow(false);
  };

  useEventListener(
    {
      name: "show_nav_bar_drawer",
      cb: setShowTrue,
    },
    [setShow],
  );
  useEventListener(
    {
      name: "hide_nav_bar_drawer",
      cb: setShowFalse,
    },
    [setShow],
  );

  const breakpoint = useBreakpointIndex();

  return (
    <motion.div
      className={cn(styles.layout_container, {
        "!pointer-events-auto ": show,
      })}
      initial={{ opacity: 0 }}
      animate={{ opacity: show ? 1 : 0 }}
      transition={{
        ease: "easeOut",
        duration: 0.2,
      }}
    >
      {breakpoint < 4 ? (
        <HyamPrismicDocumentMenuMobile document={props?.document} />
      ) : (
        <HyamPrismicDocumentMenu document={props?.document} />
      )}
    </motion.div>
  );
};

export const HyamPrismicDocumentNavBar_Drawer = withConfigure<
  HyamPrismicDocumentNavBar_DrawerProps,
  HyamPrismicDocumentNavBar_DrawerStyles
>({
  componentName: "HyamPrismicDocumentNavBar_Drawer",
  Component: _HyamPrismicDocumentNavBar_Drawer,
  moduleStyles,
});
